import Cookies from "js-cookie";
import { FullName, PhoneNumber } from "../utils/interface";
import Api from "./Api";

export interface UserRegister {
  name: {
    first: string,
    last: string,
  },
  email: string,
  phoneNumber: PhoneNumber,
  password: string,
}

export const register = async (data: UserRegister) => {
  try {
    const {
      data: {
        user,
        token,
      },
    } = await Api.post('/users/sign-up', data);
    Cookies.set('token', token);
    Cookies.set('user', JSON.stringify(user));
    Cookies.set('email', data.email);
  } catch(err) {
    throw(err.response.data);
  }
}

export interface UserLogin {
  email: string,
  password: string,
}

export const login = async (userData: UserLogin) => {
  try {
    const {
      data: {
        user,
        token,
      },
    } = await Api.post('/users/login', userData);
    Cookies.set('token', token);
    Cookies.set('user', JSON.stringify(user));
    Cookies.set('email', userData.email);
  } catch(err) {
    throw(err.response.data);
  }
};

export const forgotPassword = async (email: string) => {
  try {
    await Api.post(`/web/forgot-password`, {
      email,
    });
  } catch(err) {
    throw(err.response.data);
  }
}

export const signInCheck = async (email: string, tokenFacebook: string, tokenGoogle: string) => {
  const params: {
    email?: string,
    tokenFacebook?: string,
    tokenGoogle?: string,
  } = {};
  if (email) {
    params.email = email;
  }else if (tokenFacebook) {
    params.tokenFacebook = tokenFacebook;
  } else if (tokenGoogle) {
    params.tokenGoogle = tokenGoogle;
  } else {
    throw Error("Params is require");
  }

  try {
    const data = await Api.request('/web/sign-in-check', 'GET', {}, {}, params);
    return data;
  } catch(err) {
    throw(err.response.data);
  }
};

export const signInEmail = async (email: string, password: string, phoneNumber?: PhoneNumber) => {
  try {
    const params : {
      email: string,
      password: string,
      phoneCountryCode?: PhoneNumber['countryCode'],
      phoneNumber?: PhoneNumber['number'],
    } = {
      email,
      password,
    };

    if (phoneNumber && phoneNumber.number) {
      params.phoneCountryCode = phoneNumber.countryCode;
      params.phoneNumber = phoneNumber.number;
    }

    const data = await Api.request('/web/sign-in-email', 'GET', {}, {}, params);
    return data;
  } catch(err) {
    throw(err.response.data);
  }
};

export const signUpEmail = async (email: string, password: string, name?: FullName, phoneNumber?: PhoneNumber) => {
  try {
    const authObj: any = {
      email,
      password,
    };
    if (name) {
      authObj.name = name;
    }

    if (phoneNumber.number) {
      authObj.phoneNumber = phoneNumber;
    }

    const data = await Api.post('/web/sign-up-email', authObj);
    return data;
  } catch(err) {
    throw(err.response.data);
  }
};

export const signUpGoogle = async (token: string, phoneNumber: PhoneNumber) => {
  try {
    const data = await Api.post('/web/sign-up-google', {
      token,
      phoneNumber,
    });
    return data;
  } catch(err) {
    throw(err.response.data);
  }
};

export const signUpFacebook = async (token: string, phoneNumber: PhoneNumber) => {
  try {
    const data = await Api.post('/web/sign-up-facebook', {
      token,
      phoneNumber,
    });
    return data;
  } catch(err) {
    throw(err.response.data);
  }
};